module.exports = __webpack_public_path__ + "static/img/left-home-row-4.348cec4e.webp";